/**
 * Charcoal Threads — variant swatch in-place image swap.
 *
 * When a sibling swatch inside a `.ash-auto-cs` block is clicked:
 *   - prevent navigation to the sibling's product page
 *   - swap the card's primary slide image to the sibling's featured image
 *   - swap the card's hover-overlay image to the sibling's 2nd image (if any)
 *   - update the card's product link href so subsequent card-clicks go to the
 *     selected sibling
 *   - mark the clicked swatch as active
 *
 * Uses event delegation on document so it survives infinite-scroll loads.
 * Self-guarded so the snippet can be included multiple times safely.
 */
(function () {
  if (window.__charcoalCardSwatchesInited) return;
  window.__charcoalCardSwatchesInited = true;

  function swapImage(img, src, srcset) {
    if (!img || !src) return;
    img.removeAttribute('srcset');
    img.removeAttribute('sizes');
    img.src = src;
    if (srcset) img.setAttribute('srcset', srcset);
  }

  document.addEventListener(
    'click',
    function (event) {
      const swatch = event.target.closest('[data-charcoal-swatch]');
      if (!swatch) return;

      const card = swatch.closest('product-card');
      if (!card) return; // not inside a product card, let the link work normally

      event.preventDefault();
      event.stopPropagation();

      const primarySrc = swatch.dataset.imageSrc;
      const primarySrcset = swatch.dataset.imageSrcset;
      const secondSrc = swatch.dataset.image2Src;
      const secondSrcset = swatch.dataset.image2Srcset;
      const url = swatch.dataset.url;

      // Primary image: first slideshow-slide's product-media__image.
      const firstSlide = card.querySelector('.card-gallery slideshow-slide');
      const primaryImg = firstSlide
        ? firstSlide.querySelector('img.product-media__image') || firstSlide.querySelector('img')
        : null;
      swapImage(primaryImg, primarySrc, primarySrcset);

      // Hover overlay (rendered by card-gallery.liquid).
      const overlayImg = card.querySelector('.card-gallery__hover-overlay');
      if (overlayImg) {
        if (secondSrc) {
          swapImage(overlayImg, secondSrc, secondSrcset);
        } else if (primarySrc) {
          swapImage(overlayImg, primarySrc, primarySrcset);
        }
      }

      // Update navigable links so the card now points at the selected sibling.
      if (url) {
        const productLink = card.querySelector('.product-card__link');
        if (productLink) productLink.href = url;
        const galleryLink = card.querySelector('.card-gallery [ref="cardGalleryLink"]');
        if (galleryLink) galleryLink.href = url;
      }

      // Mark active state across this card's swatches only.
      card.querySelectorAll('[data-charcoal-swatch]').forEach((s) => s.classList.remove('is-current'));
      swatch.classList.add('is-current');
    },
    true
  );
})();
